import api from "../api";

const api_type = 'v1'

export const GetPurchaseSummary = params => { return api.post(api_type+`/purchase/summary`, params) }
export const GetPurchaseCheck = params => { return api.post(api_type+`/purchase/check`, params) }
export const GetPurchaseCheckPlatform = params => { return api.post(api_type+`/purchase/check_platform2`, params) }
export const GetPurchaseRatio = params => { return api.post(api_type+`/purchase/ratio`, params) }



// WEBPACK FOOTER //
// ./src/api/v1/purchase_api.js